<div class="h-full height-without-bar">
  <div class="mx-6 flex justify-center lg:top-0 lg:h-full lg:mx-0">
    <div class="w-full max-w-[485px] relative">
      <div class="h-full lg:px-8 2xl:px-12">
        <div class="relative lg:absolute cursor-pointer lg:top-6 mb-10 lg:mb-0 pt-6 lg:pt-0">
          <div (click)="goToLogin()" class="flex items-center gap-x-2">
            <svg class="text-theme-muted" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.219749 5.47031L3.21975 2.47031C3.51272 2.17734 3.98733 2.17734 4.28029 2.47031C4.57326 2.76328 4.57326 3.23789 4.28029 3.53085L2.56174 5.25H11.25C11.6646 5.25 12 5.58539 12 6C12 6.41461 11.6646 6.75 11.25 6.75H2.56174L4.28158 8.46984C4.57455 8.76281 4.57455 9.23742 4.28158 9.53039C3.98885 9.82312 3.51424 9.82359 3.22104 9.53039L0.221038 6.53039C-0.0732199 6.23672 -0.0732199 5.76328 0.219749 5.47031Z"
                fill="currentColor" />
            </svg>
            <span class="text-xs text-theme-muted">
              {{ "search_page.back" | translate }}
            </span>
          </div>
        </div>

        <div class="flex flex-col items-center lg:justify-center mx-auto h-full">
          <div class="mb-10 lg:mb-12">
            <img alt="logo" [src]="ImageManager.getLogoNavbarByTerritoryCode()" width="198" height="47">
          </div>

          <div class="w-full">
            <h1 class="text-center text-2xl lg:text-3xl font-semibold">
              {{ 'reset_password.title' | translate }}
            </h1>
            <p class="text-base text-center color-link mt-[0.5rem] md:mt-[1rem]">
              {{ 'reset_password.subtitle' | translate }}
            </p>

            @if (isValidating) {
              <div class="flex justify-center items-center mt-12">
                <div class="spinner-border custom-spinner" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            }

            @if (!isValidating) {
              <div>
                @if (tokenValid) {
                  <div class="p-4 rounded-lg bg-theme-primary-soft-surface text-sm text-center">
                    <p class="font-semibold">{{ emailFromToken }}</p>
                    <p class="mt-2">{{ validationMessage || ('reset_password.validation_default' | translate) }}</p>
                  </div>
                }
                @if (!tokenValid) {
                  <div class="alert alert-danger mt-6 text-sm text-center" role="alert">
                    <p>{{ tokenErrorMessage }}</p>
                    <button type="button" class="text-primary-600 font-semibold underline mt-2" (click)="goToForgotPassword()">
                      {{ 'reset_password.request_new_link' | translate }}
                    </button>
                  </div>
                }
              </div>
            }

            @if (tokenValid) {
              <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm"
                class="mt-10 lg:mt-12">
                <div class="form-group flex items-center">
                  <div class="absolute flex item-center px-3">
                    <svg fill="none" height="17" viewBox="0 0 14 17" width="14" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 6.5V4.5C3 2.3125 4.78125 0.5 7 0.5C9.1875 0.5 11 2.3125 11 4.5V6.5H11.5C12.875 6.5 14 7.625 14 9V14C14 15.4062 12.875 16.5 11.5 16.5H2.5C1.09375 16.5 0 15.4062 0 14V9C0 7.625 1.09375 6.5 2.5 6.5H3ZM4 6.5H10V4.5C10 2.84375 8.65625 1.5 7 1.5C5.3125 1.5 4 2.84375 4 4.5V6.5ZM1 14C1 14.8438 1.65625 15.5 2.5 15.5H11.5C12.3125 15.5 13 14.8438 13 14V9C13 8.1875 12.3125 7.5 11.5 7.5H2.5C1.65625 7.5 1 8.1875 1 9V14Z"
                        fill="black" opacity="0.5" />
                    </svg>
                  </div>
                  <input [type]="'password'"
                    class="custom-input bg-white border-solid-black text-base rounded-lg block w-full py-[12px] md:py-3.5 px-10"
                    formControlName="password" id="new-password" name="password"
                    placeholder="{{ 'reset_password.password_placeholder' | translate }}">
                </div>
                @if (shouldShowPasswordError) {
                  <div class="text-xs text-red-500 mt-2">
                    {{ 'reset_password.password_error' | translate }}
                  </div>
                }
                <div class="form-group flex items-center mt-6">
                  <div class="absolute flex item-center px-3">
                    <svg fill="none" height="17" viewBox="0 0 14 17" width="14" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 6.5V4.5C3 2.3125 4.78125 0.5 7 0.5C9.1875 0.5 11 2.3125 11 4.5V6.5H11.5C12.875 6.5 14 7.625 14 9V14C14 15.4062 12.875 16.5 11.5 16.5H2.5C1.09375 16.5 0 15.4062 0 14V9C0 7.625 1.09375 6.5 2.5 6.5H3ZM4 6.5H10V4.5C10 2.84375 8.65625 1.5 7 1.5C5.3125 1.5 4 2.84375 4 4.5V6.5ZM1 14C1 14.8438 1.65625 15.5 2.5 15.5H11.5C12.3125 15.5 13 14.8438 13 14V9C13 8.1875 12.3125 7.5 11.5 7.5H2.5C1.65625 7.5 1 8.1875 1 9V14Z"
                        fill="black" opacity="0.5" />
                    </svg>
                  </div>
                  <input [type]="'password'"
                    class="custom-input bg-white border-solid-black text-base rounded-lg block w-full py-[12px] md:py-3.5 px-10"
                    formControlName="confirmPassword" id="confirm-password" name="confirmPassword"
                    placeholder="{{ 'reset_password.confirm_password_placeholder' | translate }}">
                </div>
                @if (shouldShowConfirmError) {
                  <div class="text-xs text-red-500 mt-2">
                    {{ resetPasswordForm.hasError('passwordMismatch') ? ('reset_password.confirm_password_mismatch' | translate) : ('reset_password.password_error' | translate) }}
                  </div>
                }
                @if (serverErrorMessage) {
                  <div class="alert alert-danger mt-6 text-sm text-center" role="alert">
                    {{ serverErrorMessage }}
                  </div>
                }
                @if (!isSubmitting) {
                  <button [disabled]="resetPasswordForm.invalid"
                    class="custom-border-solid w-full btn-default rounded-lg text-base font-medium px-3.5 text-center mt-6 py-[12px] md:py-3.5"
                    type="submit">
                    {{ 'reset_password.cta' | translate }}
                  </button>
                }
                @if (isSubmitting) {
                  <div class="flex justify-center items-center mt-6">
                    <div class="spinner-border custom-spinner" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                }
              </form>
            }

            <div class="flex justify-center mt-10">
              <p class="text-center text-sm text-theme-muted">
                {{ 'reset_password.back_to_login_label' | translate }}
                <a (click)="goToLogin()"
                class="font-medium text-primary-600 hover:underline cursor-pointer color-link">{{ 'reset_password.back_to_login' | translate }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-full hidden lg:block">
      <div class="bg-cover bg-center h-full w-full" style="background-image: url(/assets/login-background.webp);"></div>
    </div>
  </div>
</div>
